import React, { Component } from 'react';

interface Props {
    label?: string | null;
    name?: string;
    hint?: string;
    checked: boolean;
    disabled?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

class Checkbox extends Component<Props> {
    public render() {
        const { label, checked, name, onChange, hint, disabled } = this.props;
        return (
            <>
                <div className="i-checks">
                    <label className="">
                        <input name={name} disabled={disabled} style={{ position: 'absolute', opacity: 0 }} type="checkbox" checked={checked} onChange={onChange} />
                        <div className="icheckbox_square-blue checked" style={{ position: 'relative' }}>
                            <ins
                                className="iCheck-helper"
                                style={{
                                    position: 'absolute',
                                    top: '0%',
                                    left: '0%',
                                    display: 'block',
                                    width: '100%',
                                    height: '100%',
                                    margin: 0,
                                    padding: 0,
                                    background: 'rgb(255, 255, 255)',
                                    border: 0,
                                    opacity: 0,
                                }} />
                        </div>
                        <i /> {label}
                    </label>
                </div>
                {hint && <span className="form-text m-b-none">{hint}</span>}
            </>
        );
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox.tsx